import { DateTime } from 'luxon'

import { Store } from 'pullstate'

import fetchNavbar from '../StoresFunctions/fetchNavbar'

function getStoreInit ()
{
	const store =
	{
		sub_families: [],
		status: 'pending'
	};

	store.status = window.localStorage
	.getItem('navbar@status') || store.status;

	const storage_date = window.localStorage.getItem('navbar@date');

	if (storage_date && DateTime.fromISO(storage_date).isValid)
	{
		store.date = DateTime.fromISO(storage_date).toUTC().toISO();
	}
	else
	{
		store.date = DateTime.now().toUTC().toISO();
	}

	try
	{
		store.sub_families = JSON
		.parse(window.localStorage.getItem('navbar@sub_families') || '[]');
	}
	catch (e)
	{
		store.sub_families = [];
	}

	if (!Array.isArray(store.sub_families)) store.sub_families = [];

// si les données datent de plus de 10mn on refait un fetch
	if (DateTime.fromISO(store.date) < DateTime.now().minus({ minutes: 10 }))
	{
		store.status = 'pending';
	}

	if (store.status === 'pending')
	{
		fetchNavbar();
	}

	return store;
}

const init = getStoreInit();

const NavbarStore = new Store(init);

export default NavbarStore;